/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
import "./purchase_operation_advanced.css";
import { FcPrint } from "react-icons/fc";
import { FaCartPlus } from "react-icons/fa";
import Save from "../../image/Save.png";
import { Modal } from "antd";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import reset from "../../image/reset.png";
import { useReactToPrint } from "react-to-print";
import { ComponentToPrint } from "../../components/PurchaseInvoice";
import Delete from "../../image/delete.png";
import update from "../../image/Update.png";
import { FaCartArrowDown } from "react-icons/fa";
import logo from "../../image/manaviea_attire_colorful_logo.png";
import bgimage from "../../image/manaviea_dress.jpeg";
import { IoIosSave } from "react-icons/io";
import { IoMdRefresh } from "react-icons/io";
import { BiReset } from "react-icons/bi";
import { BiPrinter } from "react-icons/bi";
import StylishHoverButtonInvoice from "../../components/StylishButtons/StylishHoverButtonInvoice";
import StylishHoverButtonReset from "../../components/StylishButtons/StylishHoverButtonReset";
import StylishHoverButtonAddToCart from "../../components/StylishButtons/StylishHoverButtonAddToCart";
import StylishInput from "../../components/StylishInputFields/StylishInputForPurchaseOperation";
import { transform } from "framer-motion";


const PurchaseOperation = () => {
    const [category, setcategory] = useState("");
    const [product_code, setProductCode] = useState("");
    const [product_name, setProductName] = useState("");
    const [product_type, setProductType] = useState("");
    const [brand, setBrand] = useState("");
    const [brandID, setBrandID] = useState("");
    const [brand_name, setBrand_name] = useState("");
    const [purchase_price, setPurchasePrice] = useState("");
    const [sale_price, setSalePrice] = useState("");
    const [quantity, setQuantity] = useState("");
    const [material_name, setMaterialName] = useState("");
    const [image, setImage] = useState("");
    const [imagePreview, setImagePreview] = useState("");
    const [color, setColor] = useState("");
    const [colorID, setColorID] = useState(null);
    const [size, setSize] = useState("");
    const [categoryId, setCategoryId] = useState(null);
    const [sizeID, setSizeID] = useState(null);
    const [rack, setRack] = useState("");
    const [rackId, setRackId] = useState(null);
    const [materialId, setMaterialId] = useState(null);
    const [categoryData, setCategoryData] = useState([]);
    const [rackData, setRackData] = useState([]);
    const [sizeData, setSizeData] = useState([]);
    const [materialData, setMaterialData] = useState([]);
    const [unitName, setUnitName] = useState("Pcs");
    const [unitID, setUnitId] = useState(null);
    const [unit, setUnit] = useState("");
    const [warranty, setWarranty] = useState("");
    const [discount, setDiscount] = useState("");
    const [discountPrice, setDiscountPrice] = useState("");
    const [productCodes, setProductCodes] = useState([]);
    const [todayDate, setTodayDate] = useState(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0]; // Format the date as 'YYYY-MM-DD'
        return formattedDate;
    });
    // eslint-disable-next-line no-unused-vars

    const [shopNameData, setShopNAmeData] = useState([]);

    const [supplierName, setSupplierName] = useState("");
    const [supplierNameID, setSupplierNameID] = useState("");
    const [Supplieraddress, setSupplierAddress] = useState("");
    const [Suppliermobile, setSupplierMobile] = useState("");
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [contributor_name, setContributorName] = useState("");
    const [address, setAddress] = useState("");
    const [mobile, setMobile] = useState("");
    const [visible, setVisible] = useState(false);
    const [brandVisible, setBrandVisible] = useState(false);
    const [rackVisiable, setRackVisiable] = useState(false);
    const [categoryVisiable, setCategoryVisiable] = useState(false);
    const [colorVisiable, setColorVisiable] = useState(false);
    const [sizeVisiable, setSizeVisiable] = useState(false);
    const [materialVisiable, setMaterilVisiable] = useState(false);

    const [unitvisible, setUnitVisible] = useState(false);
    const [vatVisible, setVatVisible] = useState(false);

    const [transactionData, setTransactionData] = useState([]);
    const [VatData, setVatData] = useState([]);
    const [paymentTypeData, setPaymentTypeData] = useState([]);
    const [unitData, setUnitData] = useState([]);
    const [brandData, setBrandData] = useState([]);
    const [data, setData] = useState([]);
    const [produtData, setProductData] = useState([]);
    const [supplierData, setSupplierData] = useState([]);
    const [tableData, setTabledata] = useState([]);
    const [totalAmount, setTotalAmount] = useState("");
    const [NettotalAmount, setNetTotalAmount] = useState("");

    const [vat, setVat] = useState(0);
    const [vatID, setVatID] = useState("");
    const [rate, setRate] = useState("");
    const [paid, setPaid] = useState("");
    const [ischecked, setIschecked] = useState(false);
    const [error, setError] = useState("");
    const [SupplierError, setSupplierError] = useState("");
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [brandError, setBrandError] = useState("");
    const [vatError, setVatError] = useState("");
    const [unitError, setunitError] = useState("");
    const [invoice, setInvoice] = useState("");
    const [product_trace_id, setProductTraceId] = useState("");
    const [paymentType, setPaymentType] = useState("Cash");
    const [payment_id, setPaymentId] = useState("");
    const [productFetchData, setProductFetchData] = useState([]);
    const [duePaid, setDuePaid] = useState("");
    const componentRef = useRef();
    const [contributorNameError, setcontributorNameError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [scrollPosition, setScrollPosition] = useState(0);
    const [filterSupplierData, setFilterSupplierData] = useState([]);
    const [searchSupplierName, setSearchSupplierName] = useState("");

    const [categoryModal, setCategoryModal] = useState(false);
    const [materialModal, setMaterialModal] = useState(false);
    const [colorModal, setColorModal] = useState(false);
    const [sizeModal, setSizeModal] = useState(false);
    const [RackModal, setRackModal] = useState(false);
    const [colorData, setColorData] = useState([]);
    const tableRef = useRef();
    const inputRefs = useRef(null);
    //date

    const today = new Date();
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const seconds = String(today.getSeconds()).padStart(2, "0");

    const fileRef = useRef(null);


    const formattedDateTime = `${todayDate} ${hours}:${minutes}:${seconds}`;

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
    });

    const Employee = localStorage.getItem("username");

    const newWidth = {
        width: "7.vw",
    };

    const Color = {
        background: "rgba(6, 52, 27, 1)",
    };

    useEffect(() => {
        document.title = "Purchase ";
    });

    const showModal = () => {
        setVisible(true);
    };
    const showBrandModal = () => {
        setBrandVisible(true);
    };

    const ShowUnitModal = () => {
        setUnitVisible(true);
    };
    const showVatModal = () => {
        setVatVisible(true);
    };

    useEffect(() => {
        if (paymentTypeData && paymentTypeData.length > 0) {
            const cashPayment = paymentTypeData.find(
                (data) => data.payment_type === paymentType
            );
            if (cashPayment) {
                setPaymentId(cashPayment.payment_type_id);
            }
        }
    }, [paymentType, paymentTypeData]);

    const fetchBrandData = async () => {
        try {
            const response = await axiosInstance.get("/brand/getAll");

            setBrandData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchDataUnit = async () => {
        try {
            const response = await axiosInstance.get("/unit/getAll");
            setUnitData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchSupplierData = async (signal) => {
        if (filterSupplierData.length > 0) {
            setSupplierData(filterSupplierData);
            HandleResetSupplier();
        }
        try {
            const response = await axiosInstance.get("/contributorname/getAll", {
                signal,
            });
            const filtered = response.data.filter(
                (item) => item && item.contributor_type_id === 2
            );
            setData(filtered);
            setFilterSupplierData(filtered);
            HandleResetSupplier();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchVatData = async (signal) => {
        try {
            const response = await axiosInstance.get("/tax/getAll", { signal });

            setVatData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchProductData = async (signal) => {
        try {
            const response = await axiosInstance.get("/producttraces/getAll", {
                signal,
            });
            const productCodes = response.data.map(item => item.product_code);
            setProductCodes(productCodes);
            setProductFetchData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleDataFetchTransaction = async (signal) => {
        try {
            // Make an HTTP GET request using axiosInstance
            const filteredTransactions = await axiosInstance.get(
                `transactionsRouter/getAllTransactionByFiltered?operation_type_id=2`,
                { signal }
            );

            setTransactionData(filteredTransactions.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    useEffect(() => {
        const controller = new AbortController();
        handleDataFetchTransaction(controller.signal);

        return () => {
            controller.abort();
        };
    }, []);
    useEffect(() => {
        const fetchData = async (signal) => {
            try {
                const response = await axiosInstance.get("/paymenttypes/getAll", {
                    signal,
                });
                setPaymentTypeData(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const fetchProductdata = async (signal) => {
            try {
                const response = await axiosInstance.get("/producttraces/getAll", {
                    signal,
                });

                
                      const productCodes = response.data.map(item => item.product_code);
                      setProductCodes(productCodes);

    
                setProductData(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        const fetchAllCategory = async (signal) => {
            try {
                const { data } = await axiosInstance.get("/category/getAll", {
                    signal,
                });

                setCategoryData(data);
            } catch (error) {
                console.log(error);
            }
        };
        const fetchAllRack = async (signal) => {
            try {
                const { data } = await axiosInstance.get("/rack/getAll", {
                    signal,
                });
                setRackData(data);
            } catch (error) {
                console.log(error);
            }
        };
        const fetchAllSize = async (signal) => {
            try {
                const { data } = await axiosInstance.get("/size/getAll", {
                    signal,
                });
                setSizeData(data);
            } catch (error) {
                console.log(error);
            }
        };
        const fetchAllMaterial = async (signal) => {
            try {
                const { data } = await axiosInstance.get("/material/getAll", {
                    signal,
                });
                setMaterialData(data);
            } catch (error) {
                console.log(error);
            }
        };
        const fetchAllColor = async (signal) => {
            try {
                const { data } = await axiosInstance.get("/color/getAll", {
                    signal,
                });
                setColorData(data);
            } catch (error) {
                console.log(error);
            }
        };
        const fetchShop = async (signal) => {
            try {
                const response = await axiosInstance.get("/shopname/getAll", {
                    signal,
                });

                setShopNAmeData(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const controller = new AbortController();
        fetchSupplierData(controller.signal);
        fetchData(controller.signal);
        fetchDataUnit(controller.signal);
        fetchProductdata(controller.signal);
        fetchBrandData(controller.signal);
        fetchShop(controller.signal);
        fetchVatData(controller.signal);
        fetchProductData(controller.signal);
        fetchAllCategory(controller.signal);
        fetchAllRack(controller.signal);
        fetchAllSize(controller.signal);
        fetchAllMaterial(controller.signal);
        fetchAllColor(controller.signal);

        return () => {
            controller.abort();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const filteredData = VatData && VatData.find((item) => item.rate === vat);
        setVatID(filteredData?.tax_id);
        if (color) {
            const filteredData =
                colorData && colorData.find((item) => item.color_name == color);
            setColorID(filteredData?.color_id);
        }
        if (size) {
            const filteredData =
                sizeData && sizeData.find((item) => item.size_name == size);
            setSizeID(filteredData?.size_id);
        }
        if (material_name) {
            const filteredData =
                materialData &&
                materialData.find((item) => item.material_name == material_name);
            setMaterialId(filteredData?.material_id);
        }

        if (category) {
            const filteredData =
                categoryData &&
                categoryData.find((item) => item.category_name == category);
            setCategoryId(filteredData?.category_id);
        }

        if (rack) {
            const filteredData =
                rackData && rackData.find((item) => item.rack_no == rack);
            setRackId(filteredData?.rack_id);
        }
    }, [
        vat,
        VatData,
        color,
        size,
        material_name,
        colorData,
        sizeData,
        materialData,
        categoryData,
        category,
        rackData,
        rack,
    ]);

    useEffect(() => {
        if (brand) {
            const filteredData = brandData.find((item) => item.brand_name === brand);
            setBrandID(filteredData?.brand_id);
        }
        const fiterBrand = unitData.find((item) => item.unit === unitName);

        setUnitId(fiterBrand?.unit_id);
    }, [brand, brandData, shopNameData, unitData, unitName]);

    useEffect(() => {
        const filteredData = data.filter((item) => item.contributor_type_id === 2);

        setSupplierData(filteredData);
    }, [data]);

    const handleCancel = () => {
        setVisible(false);
        HandleResetSupplier();
    };
    const handleBrandCancel = () => {
        setBrandVisible(false);
        setBrandError("");
        setBrand_name("");
    };
    const handleVatCancel = () => {
        setVatVisible(false);
        setVatError("");
    };
    const handleUnitCancel = () => {
        setUnitVisible(false);
        setunitError("");
        setUnit("");
    };

    useEffect(() => {
        const handleChangeSupplier = () => {
            const result = data.find(
                (item) => item.contributor_name === supplierName
            );

            if (result) {
                setSupplierNameID(result.contributor_name_id);
                setSupplierAddress(result.address);
                setSupplierMobile(result.mobile);
            } else {
                setSupplierAddress("");
                setSupplierMobile("");
            }
        };
        handleChangeSupplier();
    }, [supplierName, data]);

    useEffect(() => {
        if (tableData.length === 0) {
            setPaid("");
        }
    }, [tableData.length === 0]);

    const itemTotal =
        Math.round(parseFloat(purchase_price) * parseFloat(quantity)) || 0;

    useEffect(() => {
        if (discountPrice) {
            const discountPercentage = discountPrice
                ? ((discountPrice / itemTotal) * 100).toFixed(1)
                : "";
            setDiscount(discountPercentage);
        }
    }, [discountPrice]);

    const handleDiscount = (e) => {
        const discountAmount = (
            itemTotal *
            (parseFloat(e.target.value) / 100)
        ).toFixed(1);
        setDiscountPrice(discountAmount);
        setDiscount(e.target.value);
    };

    const totalWithDiscount = Math.floor(itemTotal - discountPrice) || itemTotal;

    useEffect(() => {
        if (vat && totalAmount) {
            const vatAmount = totalAmount * (vat / 100);
            const totalWithVAT = Math.round(totalAmount + vatAmount);
            setNetTotalAmount(totalWithVAT);
        } else {
            setNetTotalAmount(totalAmount);
        }
    }, [vat, totalAmount]);

    ///reset all

    const handleReset = () => {
        setProductCode("");
        setProductName("");
        setProductType("");
        setcategory("");
        setBrand("");
        setPurchasePrice("");
        setQuantity("");
        setDiscount("");
        setSalePrice("");
        setWarranty("");
        setSupplierName("");
        setVat("");
        setPaid("");
        setTabledata([]);

        setMaterialName("");
        setColor("");
        setSize("");

        setRack("");
        setSupplierName("");
        setPaymentType("");
        setVat(0);
        // setUnitName("");
        // setUnitId(null);
        setError("");
    };

    /// add to table

    const AddToCart = () => {
        if (
            product_code === "" &&
            purchase_price === "" &&
            quantity === "" &&
            sale_price === ""
        ) {
            // setError("Don't leave empty field");
            toast.error("Some Fields are empty");
            return;
        }

        if (product_code === "") {
          //  setError("Product Code is empty");
          toast.error("Product Code is empty");
            return;
        }
        if (purchase_price === "") {
         //   setError("Purchase Price is empty");
            toast.error("Purchase Price is empty");
            return;
        }
        if (quantity === "") {
          //  setError("Quantity is empty");
            toast.error("Quantity is empty");
            return;
        }
        // if (unitName === "") {
        //   setError("Don't leave empty field");
        //   return;
        // }
        if (sale_price === "") {
         //   setError("Sale Price is empty");
         toast.error("Sale Price is empty");
            return;
        }
        console.log("product_code:", product_code);
        console.log("productCodes:", productCodes);
        const codeToCheck = `MV=${product_code.trim()}`;

        if (productCodes.includes(codeToCheck)) {
         // setError("Duplicate Product Code!!");
         toast.error("Duplicate Product Code!!");
          return;
        }

        const newItem = {
            category: category,
            categoryId: categoryId,
            product_code: "MV=" + product_code,
            product_name: product_name,
            product_type: product_type,
            brand_name: brand,
            quantity: quantity,
            unit: unitName,
            purchase_price: purchase_price,
            item_total: itemTotal,
            discount: discount || 0,
            warranty: warranty || "none",
            total: totalWithDiscount,
            salePrice: sale_price,
            unitID: unitID || 1,
            brandId: brandID,
            colorId: colorID,
            materialId: materialId,
            size_id: sizeID,
            product_trace_id: product_trace_id,
            image_preview: imagePreview,
            image: image,
            color: color,
            size: size,
            rack: rack,
            rackId: rackId,
            material_name: material_name,
        };

        console.log("newItem", newItem);
        setTabledata((prevTableData) => [...prevTableData, newItem]);
        if (ischecked) {
            return;
        } else {
            setProductCode("");
            setBrand("");
            setPurchasePrice("");
            setQuantity("");
            setUnit(null);
            setDiscount("");
            setSalePrice("");
            setWarranty("");
            setUnitName("");
            setUnitId(null);
            setError("");
        }
    };

    useEffect(() => {
        if (tableData.length > 0) {
            const total = tableData.reduce(
                (accumulator, item) => accumulator + item.total,
                0
            );
            setTotalAmount(parseFloat(total, 10));
        } else {
            setTotalAmount(0);
        }
    }, [tableData]);

    useEffect(() => {
        if (paid) {
            setDuePaid(parseFloat(NettotalAmount) - parseFloat(paid));
        } else {
            setDuePaid(NettotalAmount);
        }
    }, [NettotalAmount, paid]);

    //all save api

    const handleSave = async (event) => {
        if (event.detail > 1) {
            return;
        }
        if (
            tableData.length === 0 &&
            (supplierName === "" || Supplieraddress === "")
        ) {
            setError("Don't leave empty field");
            setSupplierError("Don't leave empty field");
            return;
        }
        if (tableData.length === 0) {
            setError("Don't leave empty field");
            return;
        }
        if (supplierName === "") {
            setSupplierError("Don't leave empty field");
            return;
        }
        if (Supplieraddress === "") {
            setSupplierError("Please give valid supplier name or Add supplier");
            return;
        }
        if (paid < 0) {
            toast.dismiss();
            toast.warning("You Can't Paid 0 !", {
                autoClose: 1000,
            });
            return;
        }
        // const data = new FormData();
        const transactionsArray = []; // Array to accumulate transactions

        for (const item of tableData) {
            // Create form data for each product
            const data = new FormData();
            data.append("name", item.product_name);
            data.append("product_code", item.product_code);
            data.append("type", item.product_type);
            data.append("category_id", parseInt(item.categoryId));
            data.append("rack_id", item.rackId);
            data.append("size_id", item.size_id);
            const colorId = item.colorId ? parseInt(item.colorId) : 1;
            data.append("color_id", colorId);

            console.log("item.size_id" + item.size_id);
            try {
                let res;

                if (item.image) {
                    data.append("image", item.image);
                    res = await axiosInstance.post(
                        "/producttraces/postProductTraceWithImageFromAnyPage",
                        data
                    );
                } else {
                    data.append("image_id", parseInt(163));
                    res = await axiosInstance.post(
                        "/producttraces/postProductTraceWithoutImageFromAnyPage",
                        data
                    );
                }

                // Create new transaction for the saved product
                const newTransaction = {
                    product_trace_id: res.data.product_trace_id,
                    quantity_no: item.quantity,
                    unit_id: item.unitID,
                    brand_id: item.brandId || null,
                    warranty: item.warranty,
                    tax_id: 6,
                    amount: NettotalAmount,
                    authorized_by_id: 1,
                    contributor_name_id: supplierNameID || null,
                    operation_type_id: 2,
                    date: formattedDateTime,
                    payment_type_id: payment_id || null,
                    paid: paid || 0,
                    employee_id: Employee,
                    purchase_price: item.purchase_price,
                    sale_price: item.salePrice,
                    discount: item.discount,
                    shop_name_id: 1,
                    material_id: item.materialId || null,
                };

                // Add new transaction to the array
                transactionsArray.push(newTransaction);
                console.log("transactionsArray", transactionsArray);
            } catch (error) {
             //   console.error(error);
               // toast.error("Failed to save product data. Please try again later.");
                const { message, field } = error.response.data;
                toast.error(message);
                
            } finally {
                // Reset form data for the next product
                data.delete("name");
                data.delete("product_code");
                data.delete("image");
                data.delete("type");
                data.delete("category_id");
                data.delete("rack_id");
                data.delete("size_id");
                data.delete("color_id");
            }
        }

        try {
            // Bulk save all transactions after products are saved
            if (transactionsArray.length > 0) {
                const response = await axiosInstance.post(
                    "/transactionsRouter/postTransactionFromAnyPageBulk?operation_type_id=2",
                    transactionsArray,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.status === 200) {
                    handleReset();
                    toast.success("All data saved successfully!");
                } else {
                    toast.error("Failed to save transactions.");
                }
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to save transactions. Please try again later.");
        }
    };

    // console.log("tableData", tableData);

    const saveBrandName = async (event) => {
        if (brand_name === "") {
            setBrandError("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }
        const brandName =
            brandData &&
            brandData.find(
                (item) => item.brand_name.toLowerCase() === brand_name.toLowerCase()
            );
        if (brandName) {
            toast.warning("This Brand is already exist");
            setBrand_name("");
            return;
        }
        try {
            const response = await axiosInstance.post("/brand/postBrandFromAnyPage", {
                brand_name,
            });
            if (response.status === 200) {
                fetchBrandData();
                setBrand_name("");
                toast.success("Brand name saved successfully!");
            } else {
                toast.error("Failed to save brand name");
            }
        } catch (error) {
            console.error("Error saving brand name:", error);
        }
    };

    const handlesaveUnit = async (event) => {
        if (unit === "") {
            setunitError("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }
        const unitCheck =
            unitData &&
            unitData.find((item) => item.unit.toLowerCase() === unit.toLowerCase());
        if (unitCheck) {
            toast.warning("This Unit is already exist");
            setUnit("");
            return;
        }
        try {
            const response = await axiosInstance.post("/unit/postUnitFromAnyPage", {
                unit,
            });
            if (response.status === 200) {
                fetchDataUnit();
                setUnit("");
                toast.success("Unit Add successfully!");
            } else {
                toast.error("Failed to save unit ");
            }
        } catch (error) {
            console.error("Error saving Unit :", error);
        }
    };

    const handlesaveVat = async (event) => {
        if (rate === "") {
            setVatError("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }
        const VatCheck = VatData && VatData.find((item) => item.rate === rate);
        if (VatCheck) {
            toast.warning("This Vat is already exist");
            setRate("");
            return;
        }
        try {
            const response = await axiosInstance.post("/tax/postTaxFromAnyPage", {
                rate,
            });
            if (response.status === 200) {
                fetchVatData();
                setRate("");
                toast.success("Vat Add successfully!");
            } else {
                toast.error("Failed to save Vat");
            }
        } catch (error) {
            console.error("Error saving Vat:", error);
            toast.error("Error saving Vat");
        }
    };

    const fetchAllCategory = async (signal) => {
        try {
            const { data } = await axiosInstance.get("/category/getAll", {
                signal,
            });

            setCategoryData(data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchAllSize = async () => {
        try {
            const { data } = await axiosInstance.get("/size/getAll");
            setSizeData(data);
        } catch (error) {
            console.log(error);
        }
    };
    const fetchAllMaterial = async () => {
        try {
            const { data } = await axiosInstance.get("/material/getAll");
            setMaterialData(data);
        } catch (error) {
            console.log(error);
        }
    };
    const fetchAllColor = async () => {
        try {
            const { data } = await axiosInstance.get("/color/getAll");
            setColorData(data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchAllRack = async (signal) => {
        try {
            const { data } = await axiosInstance.get("/rack/getAll");
            setRackData(data);
        } catch (error) {
            console.log(error);
        }
    };

    // add category
    const [category_name, setCategoryName] = useState("");
    const handleCategorySave = async (event) => {
        if (category_name === "") {
            setCategoryName("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }

        try {
            const response = await axiosInstance.post(
                "/category/postCategoryFromAnyPage",
                {
                    category_name,
                }
            );
            if (response.status === 200) {
                fetchAllCategory();
                setCategoryName("");
                toast.success("Category Add successfully!");
            } else {
                toast.error("Failed to save Category");
            }
        } catch (error) {
            console.error("Error saving Category:", error);
            toast.error("Error saving Category");
        }
    };

    // add material
    const handleMaterialSave = async (event) => {
        if (material_name === "") {
            setMaterialName("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }

        try {
            const response = await axiosInstance.post(
                "/material/postMaterialFromAnyPage",
                {
                    material_name,
                }
            );
            if (response.status === 200) {
                fetchAllMaterial();
                setMaterialName("");
                toast.success("Material Add successfully!");
            } else {
                toast.error("Failed to save Material");
            }
        } catch (error) {
            console.error("Error saving Material:", error);
            toast.error("Error saving Material");
        }
    };

    // add Color
    const handleColorSave = async (event) => {
        if (color === "") {
            setColor("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }

        try {
            const response = await axiosInstance.post("/color/postColorFromAnyPage", {
                color_name: color,
            });
            if (response.status === 200) {
                fetchAllColor();
                setColor("");
                toast.success("Color Add successfully!");
            } else {
                toast.error("Failed to save Color");
            }
        } catch (error) {
            console.error("Error saving Color:", error);
            toast.error("Error saving Color");
        }
    };

    const [rack_no, setRackNo] = useState("");

    // add rack
    const handleRackSave = async (event) => {
        if (rack_no === "") {
            setRackNo("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }

        try {
            const response = await axiosInstance.post("/rack/postRackFromAnyPage", {
                rack_no,
            });
            if (response.status === 200) {
                fetchAllRack();
                setRackNo("");
                toast.success("Rack Add successfully!");
            } else {
                toast.error("Failed to save Rack");
            }
        } catch (error) {
            console.error("Error saving Rack:", error);
            toast.error("Error saving Rack");
        }
    };

    // add size
    const [size_name, setSizeName] = useState("");
    const handleSizeSave = async (event) => {
        if (size_name === "") {
            setSizeName("Can't leave empty field");
            return;
        }
        if (event.detail > 1) {
            return;
        }

        try {
            const response = await axiosInstance.post("/size/postSizeFromAnyPage", {
                size_name,
            });
            if (response.status === 200) {
                fetchAllSize();
                setSizeName("");
                toast.success("Size Add successfully!");
            } else {
                toast.error("Failed to save Size");
            }
        } catch (error) {
            console.error("Error saving Size:", error);
            toast.error("Error saving Size");
        }
    };

    //save supplier
    const handleSaveSupplier = async () => {
        if (setContributorName === "" && setAddress === "" && setMobile === "") {
            toast.warning("Please fill all field");
            return;
        }
        if (contributor_name === "" && (address === "") & (mobile === "")) {
            setcontributorNameError("Can't leave empty field");
            setAddressError("Can't leave empty field");
            setMobileError("Can't leave empty field");
            return;
        }
        if (contributor_name === "") {
            setcontributorNameError("Can't leave empty field");

            return;
        }
        if (address === "") {
            setAddressError("Can't leave empty field");
            return;
        }
        if (mobile === "") {
            setMobileError("Can't leave empty field");
            return;
        }
        const contributor_type_id = 2;

        try {
            const response = await axiosInstance.post(
                "/contributorname/postContributorNameFromAnyPage",
                {
                    contributor_name: contributor_name.replace(/\s+/g, " ").trim(),
                    address,
                    mobile,
                    contributor_type_id,
                }
            );
            if (response.status === 200) {
                fetchSupplierData();
                setContributorName("");
                setAddress("");
                setMobile("");
                toast.success("Supplier Add successfully!");
            } else {
                toast.error("Failed to save Supplier");
            }
        } catch (error) {
            console.error("Error saving brand name:", error);
        }
    };
    // delete supplier
    const handleDeleteSupplier = async () => {
        if (supplierId === null) {
            alert("Please select row");
            return;
        }
        const confirmDelete = window.confirm("Are you sure delete Supplier?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/contributorname/deleteContributorNameByID?contributor_name_id=${supplierId}`
                );

                if (response.status === 200) {
                    fetchSupplierData();
                    setSupplierId(null);

                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };
    // delete brand
    const handleDeleteBrand = async () => {
        if (brandId === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete Brand?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/brand/deleteBrandByID?brand_id=${brandId}`
                );

                if (response.status === 200) {
                    fetchBrandData();
                    setBrandId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };
    //delete unit
    const handleDeleteUnit = async () => {
        if (unitID === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete Unit?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/unit/deleteUnitByID?unit_id=${unitID}`
                );

                if (response.status === 200) {
                    fetchDataUnit();
                    setUnitId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };
    // delete category
    const handleDeleteCategory = async () => {
        if (categoryId === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete Catagory?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/category/deleteCategoryFromAnyPage?category_id=${categoryId}`
                );

                if (response.status === 200) {
                    fetchAllCategory();
                    setCategoryId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };

    // delete material
    const handleDeleteMaterial = async () => {
        if (materialId === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete Material?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/material/deleteMaterialByID?material_id=${materialId}`
                );

                if (response.status === 200) {
                    fetchAllMaterial();
                    setMaterialId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };

    // delete material
    const handleDeleteColor = async () => {
        if (colorID === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete Color?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/color/deleteColorByID?id_color=${colorID}`
                );

                if (response.status === 200) {
                    fetchAllColor();
                    setCategoryId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };

    // delete rack
    const handleDeleteRack = async () => {
        if (rackId === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete rack?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/rack/deleteRackFromAnyPage?rack_id=${rackId}`
                );

                if (response.status === 200) {
                    fetchAllRack();
                    setRackId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };
    // delete Size
    const handleDeleteSize = async () => {
        if (sizeID === null) {
            alert("Please select row");
            return;
        }

        const confirmDelete = window.confirm("Are you sure delete Size?");

        if (confirmDelete) {
            try {
                const response = await axiosInstance.delete(
                    `/size/deleteSizeByID?id_size=${sizeID}`
                );

                if (response.status === 200) {
                    fetchAllSize();
                    setBrandId(null);
                    toast.success("Successfully deleted row");
                } else {
                    console.log(`Error while deleting row`);
                }
            } catch (error) {
                console.log(error.message);
                alert(error.message);
            }
        } else {
            console.log("ok");
        }
    };

    //update supplier
    const handleupdateSupplier = async (event) => {
        if (event.detail > 1) {
            return;
        }
        if (supplierId === null) {
            alert("Please select row");
            return;
        }

        try {
            const response = await axiosInstance.put(
                `contributorname/updateContributorNameByID`,
                {
                    contributor_name_id: supplierId,
                    contributor_name,
                    mobile,
                    address,
                }
            );

            if (response.status === 200) {
                fetchSupplierData();
                setContributorName("");
                setAddress("");
                setMobile("");
                toast.success("Successfully Update Supplier");
            } else {
                console.log(`Error updateing Supplier `);
            }
        } catch (error) {
            console.log(error.message);
            alert(error.message);
        }
    };

    console.log("cetegory", categoryId);

    const handlePaidChange = (e) => {
        const newPaid = parseFloat(e.target.value);

        if (newPaid > NettotalAmount) {
            toast.dismiss();
            toast.warning("Paid amount cannot exceed Net Total", {
                autoClose: 1000,
            });
        } else if (newPaid < 0) {
            toast.dismiss();
            toast.warning("Paid amount cannot Decrease 0", {
                autoClose: 1000,
            });
        } else {
            setPaid(newPaid);
        }
    };

    // select supplier row

    const [supplierId, setSupplierId] = useState(null);

    const handleSupplierRow = (item) => {
        if (supplierId === item.contributor_name_id) {
            setSupplierId(null);

            setContributorName("");
            setAddress("");
            setMobile("");
        } else {
            setSupplierId(item.contributor_name_id);
            setScrollPosition(tableRef.current.scrollTop);
            setContributorName(item.contributor_name);
            setAddress(item.address);
            setMobile(item.mobile);
        }
    };

    const handleRowClick = (rowIndex) => {
        const newSelectedRows = new Set(selectedRows);

        if (newSelectedRows.has(rowIndex)) {
            newSelectedRows.delete(rowIndex);
            setActiveRowIndex(null); // If already selected, deselect it
        } else {
            newSelectedRows.clear(); // Clear all selected rows
            newSelectedRows.add(rowIndex); // Select the clicked row
            setActiveRowIndex(rowIndex);
        }

        setSelectedRows(newSelectedRows); // Update selected rows state
    };

    const deleteRows = (rowsToDelete) => {
        const rowsSet = new Set(rowsToDelete);
        const updatedItems = tableData.filter((item, index) => !rowsSet.has(index));
        setTabledata(updatedItems);
        setSelectedRows(new Set()); // Clear selected rows after deletion
        setActiveRowIndex(null); // Clear active row index
    };

    // Function to handle keydown events
    const handleKeyDown = (e) => {
        if (e.key === "Delete") {
            if (activeRowIndex === null) {
                alert("Plaese select a row");
                return;
            }
            const confirmDelete = window.confirm(
                "Are you sure you want to delete this row?"
            );
            if (confirmDelete) {
                deleteRows([...selectedRows]);
            }
        }
    };

    // Add event listener when the component mounts
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown); // Remove event listener when component unmounts
        };
    }, [tableData, selectedRows, handleKeyDown]);

    const handleCheckboxChange = () => {
        setIschecked((prevState) => !prevState); // Toggle the isChecked state
    };

    useEffect(() => {
        if (tableRef.current !== null) {
            tableRef.current?.scrollTo({ top: scrollPosition });
        }
    }, [supplierData, scrollPosition]);

    const [brandId, setBrandId] = useState(null);

    const handleBrandRow = (item) => {
        if (brandId === item.brand_id) {
            setBrandId(null);
        } else {
            setBrandId(item.brand_id);
        }
    };

    const handleCategoryRow = (item) => {
        if (categoryId === item.category_id) {
            setCategoryId(null);
        } else {
            setCategoryId(item.category_id);
        }
    };

    const handleMaterialRow = (item) => {
        if (materialId === item.material_id) {
            setMaterialId(null);
        } else {
            setMaterialId(item.material_id);
        }
    };

    const handlColorRow = (item) => {
        if (colorID === item.id_color) {
            setColorID(null);
        } else {
            setColorID(item.id_color);
        }
    };

    const handlSizeRow = (item) => {
        if (sizeID === item.id_size) {
            setSizeID(null);
        } else {
            setSizeID(item.id_size);
        }
    };

    const handlRackRow = (item) => {
        if (rackId === item.rack_id) {
            setRackId(null);
        } else {
            setRackId(item.rack_id);
        }
    };
    const HandleResetSupplier = () => {
        setContributorName("");
        setMobile("");
        setAddress("");
        setSupplierId(null);
        setSearchSupplierName("");
    };

    /// search system supplier

    const handleSupplierSearch = () => {
        const filter = filterSupplierData?.filter((item) =>
            item.contributor_name
                .toLocaleLowerCase()
                .includes(searchSupplierName.toLocaleLowerCase())
        );
        setData(filter);
    };
    const handleUnitRow = (item) => {
        if (unitID === item.unit_id) {
            setUnitId(null);
        } else {
            setUnitId(item.unit_id);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file);
        if (file) {
            // Create a preview URL for the image
            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        }
    };

    const role = localStorage.getItem("role");
    // console.log("role", role);
    const generateHybridCode = () => {
        const timestampPart = Date.now().toString().slice(-6); // Last 6 digits of timestamp
        const randomPart = Math.floor(Math.random() * 1000)
            .toString()
            .padStart(3, "0"); // 000–999
        const code = Number(timestampPart + randomPart); // Keep it base-10, as a large integer
        setProductCode(code);
        return code;
    };
    // console.log("rackid", rackId);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} />
            <div
                className="full_div"
                style={{
                    background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                }}
            >
                <div
                    style={{
                        width: "100vw",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(249, 176, 191, 0.3)", /* soft pink */
                        boxShadow: "0 0 10px rgba(0, 0, 0, 1)", // optional
                        color: "#000000",
                        fontWeight: "bold",
                        fontSize: "2.5vh",
                        height: "6vh",
                    }}
                >
                    <img
                        src={logo}

                        style={{
                            width: "2vw",
                            height: "2vw",
                            borderRadius: "50%",
                            objectFit: "cover", // ensures image fills the circle nicely
                            border: "2px solid #ccc", // optional
                            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", // optional
                        }}
                        alt="Logo" />
                    <p
                        className="heading"
                    >
                        Purchase Operation
                    </p>

                    {/* <img src={lady} alt="" /> */}
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                    }}
                >

                    <div
                        className="first_row_div"
                        style={{
                            background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                        }}
                    >
                        <div
                            className="invisible_div"
                            style={{
                                background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                            }}
                        >

                            <div
                                style={{
                                    width: "83vw",
                                    height: "27vh",
                                    background: "rgba(255, 230, 240, 0.3)",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "left",
                                    alignItems: "left",
                                    columnGap: "4vw",
                                    borderRadius: "0.5vw",
                                }}
                            >
                                <div             // first row first column
                                    style={{
                                        background: "rgba(255, 230, 240, 0.0)",
                                        display: "flex",
                                        rowGap: ".5vh",
                                        flexDirection: "column",
                                        justifyContent: "left",
                                        alignItems: "left",
                                        paddingTop: "3.5vh"
                                    }}
                                >
                                    {/* Category */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                            gap: "1vw",
                                        }}
                                    >

                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Category*"
                                            labelDisplacement="-3vw"
                                            translateXInput="6.5vw"
                                            translateYInput="0vw"
                                            translateXLabel="2vw"
                                            translateYLabel="-1vh"
                                            value={category}
                                            onChange={(e) => setcategory(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={true}
                                            list="category_list"
                                        />

                                        <datalist id="category_list">
                                            {categoryData.length > 0 &&
                                                categoryData.map((item, index) => {
                                                    return (
                                                        <option key={index}>
                                                            {item.category_name}
                                                        </option>
                                                    );
                                                })}
                                        </datalist>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    transform: "translateX(6vw)"
                                                }}
                                                onClick={() => setCategoryModal(true)}
                                            >
                                                +
                                            </button>
                                            <div
                                                className="error_message"
                                                style={{ marginLeft: "3.3vw" }}
                                            >
                                                {error && category === "" ? error : ""}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Product Code */}
                                    <div>
                                        <div
                                            style={{
                                                marginLeft: "6.7vw",
                                            }}
                                        >
                                            <input
                                                type="text"
                                                onChange={(e) => {
                                                    setError("");
                                                }}
                                                value={"MV="}
                                                className="input_field_supershop_purchase_long"
                                                style={{
                                                    borderColor:
                                                        error && product_code === "" ? "red" : "",
                                                    width: "2.5vw",
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "1vw",
                                            }}
                                        >

                                            <div>

                                                <StylishInput
                                                    inputWidth="10vw"
                                                    inputHeight="3.5vh"
                                                    type="number"
                                                    label="Code*"
                                                    labelDisplacement="-3vw"
                                                    translateXInput="5.2vw"
                                                    translateYInput="0vw"
                                                    translateXLabel="1vw"
                                                    translateYLabel="-1vh"
                                                    value={product_code}
                                                    onChange={(e) => setProductCode(e.target.value)}
                                                    disabled={false}
                                                    justReadOnly ={false}

                                                />

                                            </div>

                                        </div>

                                    </div>



                                    {/* Product Name */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "1vw",
                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="P Name*"
                                            labelDisplacement="-4vw"
                                            translateXInput="5.2vw"
                                            translateYInput="0vw"
                                            translateXLabel="1vw"
                                            translateYLabel="-1vh"
                                            value={product_name}
                                            onChange={(e) => setProductName(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={false}
                                        />



                                    </div>

                                    {/* Product Type */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "1vw",
                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="P Type*"
                                            labelDisplacement="-3.5vw"
                                            translateXInput="5.2vw"
                                            translateYInput="0vw"
                                            translateXLabel="1vw"
                                            translateYLabel="-1vh"
                                            value={product_type}
                                            onChange={(e) => setProductType(e.target.value)}
                                            disabled={false}
                                            justReadOnly={false}
                                        />



                                    </div>

                                    {/* Same Product (Multi Barcode) */}
                                    <div
                                        className="barcode_check_box_purchase" style={{ marginTop: "0.5vw" }}>
                                        <input
                                            type="checkbox"
                                            checked={ischecked}
                                            onChange={handleCheckboxChange}
                                        />
                                        Same Product (Multi Barcode)
                                    </div>
                                </div>

                                <div         //1st row 2nd column
                                    style={{
                                        background: "rgba(255, 230, 240, 0.0)",
                                        display: "flex",
                                        rowGap: ".5vh",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >


                                    {/* Brand */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Brand"
                                            labelDisplacement="-1vw"
                                            translateXInput="7vw"
                                            translateYInput="0vw"
                                            translateXLabel="2.5vw"
                                            translateYLabel="-1vh"
                                            value={brand}
                                            onChange={(e) => setBrand(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={true}
                                            list="brand_list"
                                        />
                                        <datalist id="brand_list">
                                            {brandData.length > 0 &&
                                                brandData.map((brand, index) => {
                                                    return (
                                                        <option key={index}>{brand.brand_name}</option>
                                                    );
                                                })}
                                        </datalist>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    pointerEvents: "auto",

                                                    transform: "translateX(7.5vw)",
                                                    position: "relative",
                                                    zIndex: 9999   // ⭐ fixes click!
                                                }}

                                                onClick={showBrandModal}
                                            >
                                                +
                                            </button>
                                        </div>


                                    </div>

                                    {/* Material */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Material"
                                            labelDisplacement="-1.7vw"
                                            translateXInput="7vw"
                                            translateYInput="0vw"
                                            translateXLabel="2.5vw"
                                            translateYLabel="-1vh"
                                            value={material_name}
                                            onChange={(e) => setMaterialName(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={true}
                                            list="material_list"
                                        />
                                        <datalist id="material_list">
                                            {materialData.length > 0 &&
                                                materialData.map((item, index) => {
                                                    return (
                                                        <option key={index}>
                                                            {item.material_name}
                                                        </option>
                                                    );
                                                })}
                                        </datalist>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    transform: "translateX(7.5vw)",
                                                    position: "relative",
                                                    zIndex: 9999   // ⭐ fixes click!
                                                }}
                                                onClick={() => setMaterialModal(true)}
                                            >
                                                +
                                            </button>
                                        </div>


                                    </div>

                                    {/* Color */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Color*"
                                            labelDisplacement="-1vw"
                                            translateXInput="7vw"
                                            translateYInput="0vw"
                                            translateXLabel="2.5vw"
                                            translateYLabel="-1vh"
                                            value={color}
                                            onChange={(e) => setColor(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={true}
                                            list="color_list"
                                        />
                                        <datalist id="color_list">
                                            {colorData.length > 0 &&
                                                colorData.map((item, index) => {
                                                    return (
                                                        <option key={index}>{item.color_name}</option>
                                                    );
                                                })}
                                        </datalist>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    transform: "translateX(7.5vw)",
                                                    position: "relative",
                                                    zIndex: 9999   // ⭐ fixes click!
                                                }}
                                                onClick={() => setColorModal(true)}
                                            >
                                                +
                                            </button>
                                        </div>


                                    </div>

                                    {/* Image */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        {/* <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="file"
                                            label="Image"
                                            labelDisplacement="-1vw"
                                            translateXInput="6.2vw"
                                            translateYInput="0vw"
                                            translateXLabel="5.3vw"
                                            translateYLabel="-1vh"
                                            onChange={(e) => handleImageChange(e)}
                                            disabled={false}
                                        /> */}
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "10vw",
                                                transform: "translateX(6.25vw)"

                                            }}>
                                            <button
                                                onClick={() => fileRef.current.click()}
                                                style={{
                                                    width: "10vw",
                                                    height: "3.5vh",
                                                    borderRadius: "6px",
                                                    background: "rgba(255, 230, 240, 0.3)",
                                                    border: "1px solid #ff69b4",
                                                    cursor: "pointer",
                                                    fontWeight: "normal",
                                                }}
                                            >
                                                Upload Image
                                            </button>

                                            <input
                                                ref={fileRef}
                                                type="file"
                                                style={{ display: "none" }}
                                                onChange={(e) => handleImageChange(e)}
                                            />
                                        </div>



                                    </div>


                                </div>


                                <div           //1st row 3rd column
                                    style={{
                                        background: "rgba(255, 230, 240, 0.0)",
                                        display: "flex",
                                        rowGap: ".5vh",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {/* Size */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Size"
                                            labelDisplacement="1.5vw"
                                            translateXInput="9.2vw"
                                            translateYInput="0vw"
                                            translateXLabel="4.8vw"
                                            translateYLabel="-1vh"
                                            value={size}
                                            onChange={(e) => setSize(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={true}
                                            list="size_list"
                                        />
                                        <datalist id="size_list">
                                            {sizeData.length > 0 &&
                                                sizeData.map((item, index) => {
                                                    return (
                                                        <option key={index}>{item.size_name}</option>
                                                    );
                                                })}
                                        </datalist>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    transform: "translateX(9.7vw)",
                                                    position: "relative",
                                                    zIndex: 9999   // ⭐ fixes click!
                                                }}
                                                onClick={() => setSizeModal(true)}
                                            >
                                                +
                                            </button>
                                        </div>


                                    </div>

                                    {/* Purchase Price */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Pur Price*"
                                            labelDisplacement="-1.5vw"
                                            translateXInput="8.4vw"
                                            translateYInput="0vw"
                                            translateXLabel="4vw"
                                            translateYLabel="-1vh"
                                            value={purchase_price === 0 ? "" : purchase_price}
                                            onChange={(e) => {
                                                if (role === "ROLE_ADMIN") {
                                                    setPurchasePrice(e.target.value);
                                                    setError("");
                                                }
                                            }}
                                            readOnly={role !== "ROLE_ADMIN"}
                                            disabled={false}
                                            justReadOnly ={false}
                                        />



                                    </div>

                                    {/* Quantity */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",


                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="7vw"
                                            inputHeight="3.5vh"
                                            type="number"
                                            label="Quantity*"
                                            labelDisplacement="1vw"
                                            translateXInput="9vw"
                                            translateYInput="0vw"
                                            translateXLabel="6vw"
                                            translateYLabel="-1vh"
                                            value={quantity}
                                            onChange={(e) => setQuantity(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={false}
                                        />

                                        <div

                                        >
                                            <select
                                                type="text"
                                                value={unitName}
                                                onChange={(e) => {
                                                    setUnitName(e.target.value);

                                                    setError("");
                                                }}
                                                style={{
                                                    width: "2.5vw",
                                                    transform: "translateX(9.4vw)",
                                                    height: "1.6vw",
                                                    boxShadow: "0 0px 0px 1px rgba(145, 141, 141, 0.5)",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    borderColor: error && unitName === "" ? "red" : "",
                                                    color: "black",
                                                }}


                                            >
                                                <option value="" disabled selected>

                                                </option>
                                                {unitData &&
                                                    unitData.map((data, index) => (
                                                        <option
                                                            style={{ color: "black" }}
                                                            key={index}
                                                            value={data.unit}
                                                        >
                                                            {data.unit}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    transform: "translateX(10vw)",
                                                    position: "relative",
                                                    zIndex: 9999   // ⭐ fixes click!
                                                }}
                                                onClick={ShowUnitModal}
                                            >
                                                +
                                            </button>
                                        </div>




                                    </div>

                                    {/* Item Total */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="number"
                                            label="Item Total*"
                                            labelDisplacement="-1.5vw"
                                            translateXInput="8.4vw"
                                            translateYInput="0vw"
                                            translateXLabel="4vw"
                                            translateYLabel="-1vh"
                                            value={itemTotal === 0 ? "" : itemTotal}
                                            disabled={false}
                                            justReadOnly ={true}
                                        />

                                    </div>
                                </div>

                                <div //1st row 4th column

                                    style={{
                                        background: "rgba(255, 230, 240, 0.0)",
                                        display: "flex",
                                        rowGap: ".5vh",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {/* Discount */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="3.5vw"
                                            inputHeight="3.5vh"
                                            type="number"
                                            label="Disc"
                                            labelDisplacement="6vw"
                                            translateXInput="11.7vw"
                                            translateYInput="0vw"
                                            translateXLabel="10.5vw"
                                            translateYLabel="-1vh"
                                            value={discount}
                                            onChange={(e) => { handleDiscount(e); }}
                                            disabled={false}


                                        />
                                        <span
                                            style={{
                                                fontWeight: "bold",
                                                margin: " 0px 1px",
                                                transform: "translateX(12vw)"
                                            }}
                                        >
                                            %
                                        </span>

                                        <StylishInput
                                            inputWidth="5.2vw"
                                            inputHeight="3.5vh"
                                            type="number"
                                            label="amount"
                                            labelDisplacement="15vw"
                                            translateXInput="12vw"
                                            translateYInput="0vw"
                                            translateXLabel="10.2vw"
                                            translateYLabel="-1vh"
                                            value={discountPrice}
                                            onChange={(e) => {
                                                setDiscountPrice(e.target.value);
                                            }}
                                            disabled={false}
                                            justReadOnly ={true}
                                        />


                                    </div>

                                    {/* Total */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="number"
                                            label="Total*"
                                            labelDisplacement="4vw"
                                            translateXInput="12vw"
                                            translateYInput="0vw"
                                            translateXLabel="8vw"
                                            translateYLabel="-1vh"

                                            value={totalWithDiscount === 0 ? "" : totalWithDiscount}
                                            disabled={false}
                                            justReadOnly ={true}

                                        />


                                    </div>

                                    {/* Sale Price */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="number"
                                            label="Sale Price*"
                                            labelDisplacement="2vw"
                                            translateXInput="12vw"
                                            translateYInput="0vw"
                                            translateXLabel="8vw"
                                            translateYLabel="-1vh"
                                            value={sale_price}
                                            onChange={(e) => setSalePrice(e.target.value)}
                                            disabled={false}
                                        />



                                    </div>

                                    {/* Rack No */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",

                                        }}
                                    >



                                        <StylishInput
                                            inputWidth="10vw"
                                            inputHeight="3.5vh"
                                            type="text"
                                            label="Rack No"
                                            labelDisplacement="3.5vw"
                                            translateXInput="12.8vw"
                                            translateYInput="0vw"
                                            translateXLabel="8.8vw"
                                            translateYLabel="-1vh"
                                            value={rack}
                                            onChange={(e) => setRack(e.target.value)}
                                            disabled={false}
                                            justReadOnly ={true}
                                            list="rack_list"
                                        />
                                        <datalist id="rack_list">
                                            {rackData.length > 0 &&
                                                rackData.map((item, index) => {
                                                    return (
                                                        <option key={index}>{item.rack_no}</option>
                                                    );
                                                })}
                                        </datalist>

                                        <div>
                                            <button
                                                className="brand_add_button"
                                                style={{
                                                    transform: "translateX(13.5vw)",
                                                    position: "relative",
                                                    zIndex: 9999   // ⭐ fixes click!
                                                }}
                                                onClick={() => setRackModal(true)}
                                            >
                                                +
                                            </button>
                                        </div>


                                    </div>
                                </div>


                                <div   // 1st row 5th column 
                                    /* Add to Cart & Checkbox */
                                    style={{
                                        background: "rgba(255, 230, 240, 0.0)",
                                        display: "flex",
                                        rowGap: ".5vh",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        transform: "translateX(10vw)"
                                    }}

                                >
                                    {/* <button 
                                    style={{
                                        transform:"translateX(10vw)"
                                    }}
                                    onClick={AddToCart}>
                                        <FaCartArrowDown className="cart_icon_purchase" />

                                    </button> */}
                                    <StylishHoverButtonAddToCart
                                        onClick={AddToCart}
                                    />
                                    <span>Add To Cart</span>
                                </div>


                            </div>






                            <div
                                className="image_preview_box_purchase"
                                style={{
                                    background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                                }}
                            >
                                {imagePreview ? (
                                    <img
                                        src={imagePreview}
                                        style={{
                                            width: "10vw",
                                            height: "10vw"
                                        }}
                                        alt="Image preview"
                                        className="image_preview"
                                    />
                                ) : (
                                    <img
                                        src="https://images.vexels.com/media/users/3/131734/isolated/preview/05d86a9b63d1930d6298b27081ddc345-photo-preview-frame-icon.png"

                                        alt="Image preview"
                                        className="image_preview_icon"
                                    />
                                )}
                            </div>
                        </div>


                    </div>






                    <div

                        style={{
                            background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                            width: "95vw",

                        }}
                    >
                        <div className="third_row_div"
                            style={{
                                marginLeft: "1.3vw",
                                width: "95vw",
                                background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                            }}
                        >
                            <div

                                className="table_div_supershop_purchase"
                                style={{
                                    marginLeft: ".5vw",
                                    marginTop: ".5vw",
                                    width: "94vw",
                                    background: "rgba(255, 230, 240, 0.3)",
                                }}
                            >
                                <div


                                    style={{
                                        background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                                        width: "95vw",



                                    }}
                                >
                                    <table

                                        style={{
                                            width: "94vw",
                                            background: "rgba(255, 230, 240, 0.3)",
                                        }}

                                        border={2}
                                        cellSpacing={2}
                                        cellPadding={6}
                                    >
                                        <thead style={{
                                            background: "linear-gradient(90deg, #ffaeb4)",
                                            width: "93vw",

                                        }}> {/* inline CSS here */}
                                            <tr

                                            >
                                                <th style={{ width: "4vw" }}
                                                >S.No</th>
                                                <th style={{ width: "5.7vw" }}
                                                >Category</th>
                                                <th style={{ width: "15vw" }}
                                                >P.Code</th>
                                                <th style={{ width: "8vw" }}
                                                >P.Name</th>
                                                <th style={{ width: "5vw" }}
                                                >P.Type</th>
                                                <th style={{ width: "5vw" }}
                                                >Rack</th>
                                                <th style={{ width: "5vw" }}
                                                >Brand</th>
                                                <th style={{ width: "5vw" }}
                                                >Material</th>
                                                <th style={{ width: "8vw" }}
                                                >Image</th>
                                                <th style={{ width: "5vw" }}
                                                >Color</th>
                                                <th style={{ width: "5vw" }}
                                                >Size</th>
                                                <th style={{ width: "5vw" }}
                                                >Quantity</th>
                                                <th style={{ width: "5vw" }}
                                                >Unit</th>
                                                <th style={{ width: "5vw" }}
                                                >Purchase Price</th>
                                                <th style={{ width: "5vw" }}
                                                >Sale Price</th>
                                                <th style={{ width: "5vw" }}
                                                >Item Total</th>
                                                <th style={{ width: "5vw" }}
                                                >Discount</th>

                                                <th style={{ width: "5vw" }}
                                                >Total</th>
                                            </tr>
                                        </thead>
                                        <tbody
                                            style={{
                                                width: "98w",
                                                background: "rgba(255, 230, 240, 0.3)",
                                            }}


                                        >
                                            {tableData.length > 0 &&
                                                tableData.map((row, index) => (
                                                    <tr
                                                        key={index}
                                                        className={
                                                            activeRowIndex === index ? "active-row" : ""
                                                        }
                                                        onClick={() => handleRowClick(index)}

                                                        // 👇 Hover simulation
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = "#ffa6ed"; // light pink
                                                            e.currentTarget.style.transition = "background-color 0.2s ease";
                                                            e.currentTarget.style.cursor = "pointer";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            // reset color
                                                            e.currentTarget.style.backgroundColor =
                                                                activeRowIndex === index ? "#ffcbd7" : "transparent";
                                                        }}

                                                        style={{
                                                            backgroundColor:
                                                                activeRowIndex === index ? "#ffcbd7" : "transparent",
                                                        }}
                                                    >
                                                        <td
                                                        >{index + 1}</td>
                                                        <td
                                                        >{row.category}</td>
                                                        <td
                                                        >{row.product_code}</td>
                                                        <td
                                                        >{row.product_name}</td>
                                                        <td
                                                        >{row.product_type}</td>
                                                        <td
                                                        >{row.rack}</td>
                                                        <td
                                                        >{row.brand_name}</td>
                                                        <td
                                                        >{row.material_name}</td>
                                                        <td>
                                                            <img
                                                                src={row.image_preview}
                                                                alt="  Image preview..."
                                                                className="image_preview_table"
                                                            />
                                                        </td>
                                                        <td
                                                        >{row.color}</td>
                                                        <td
                                                        >{row.size}</td>
                                                        <td
                                                        >{row.quantity}</td>
                                                        <td>{row.unit}</td>
                                                        <td>{row.purchase_price}</td>
                                                        <td>{row.salePrice}</td>
                                                        <td>{row.item_total}</td>

                                                        <td>{row.discount}</td>
                                                        <td>{row.total}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                            <div className="input_field_short_total">
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "1vw",
                                    }}
                                    className="label_field_supershop_purchase"
                                >
                                    Total
                                </label>
                                <input
                                    style={{ fontSize: "1vw" }}
                                    className="input_field_supershop_purchase"
                                    value={totalAmount}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className="second_row_view"
                        style={{
                            width: "94.7vw",
                            background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                        }}
                    >
                        <div
                            className="second_row_div"
                            style={{
                                width: "94.7vw",
                                background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                            }}
                        >
                            <fieldset
                                className="customer_fieldset"
                                style={{
                                    background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                                }}
                            >
                                <div
                                    style={{
                                        marginLeft: "1vw",
                                        marginTop: ".3vw",
                                        fontSize: "1vw",
                                    }}
                                >
                                    Vendor/Supplier
                                </div>

                                <div
                                    className="customer_inner_div2"
                                    style={{
                                        background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                                    }}
                                >
                                    <div className="input_field_long_supplier">
                                        <label className="label_field_supershop_purchase">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            className="add_supplier_select_input"
                                            value={supplierName}
                                            onChange={(e) => {
                                                setSupplierName(e.target.value);
                                                setSupplierError("");
                                            }}
                                            style={{
                                                borderColor:
                                                    SupplierError &&
                                                        (supplierName === "" || Supplieraddress === "")
                                                        ? "red"
                                                        : "",
                                            }}
                                            list="list_supplier"
                                        />
                                        <datalist id="list_supplier">
                                            {supplierData.length > 0 &&
                                                supplierData.map((supplier, index) => {
                                                    return (
                                                        <option key={index}>
                                                            {supplier.contributor_name}
                                                        </option>
                                                    );
                                                })}
                                        </datalist>

                                        <button className="supplier_add_button" onClick={showModal}>
                                            +
                                        </button>
                                        <div className="error_message_supllier">
                                            {SupplierError &&
                                                (supplierName === "" || Supplieraddress === "")
                                                ? SupplierError
                                                : ""}
                                        </div>
                                    </div>
                                    <div className="input_field_long_supplier">
                                        <label className="label_field_supershop_purchase">
                                            Address
                                        </label>
                                        <input value={Supplieraddress} />
                                    </div>
                                    <div className="input_field_long_supplier">
                                        <label className="label_field_supershop_purchase">
                                            Mobile
                                        </label>
                                        <input value={Suppliermobile} />
                                    </div>
                                </div>
                            </fieldset>
                            <div
                                className="total_div_supershop_purchase"
                                style={{
                                    background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                                }}
                            >
                                <div
                                    className="input_field_short_purchase"

                                >
                                    <label
                                        className="label_field_supershop_purchase"
                                        style={newWidth}
                                    >
                                        Total
                                    </label>
                                    <input type="number" style={newWidth} value={totalAmount} />
                                </div>
                                {/* <div className="input_field_short_purchase">
              <label
                className="label_field_supershop_purchase"
                style={newWidth}
              >
                Total Discount
              </label>
              <input type="number" style={newWidth} value={totalDiscount} />
            </div> */}
                                <div className="input_field_short_purchase">
                                    <label
                                        className="label_field_supershop_purchase"
                                        style={newWidth}
                                    >
                                        Vat
                                    </label>
                                    <select
                                        type="number"
                                        value={vat}
                                        onChange={(e) => setVat(e.target.value)}
                                        className="vat_input_purchase_operation"
                                    >
                                        {VatData.length > 0 &&
                                            VatData.map((vat) => {
                                                return (
                                                    <option key={vat.tax_id} value={vat.rate}>
                                                        {vat.rate}
                                                    </option>
                                                );
                                            })}
                                    </select>

                                    <span>%</span>
                                    <button className="vat_add_button" onClick={showVatModal}>
                                        +
                                    </button>
                                </div>
                                <div className="bar_net_total">
                                    <div className="input_field_short_purchase bar_total_purchase">
                                        <label
                                            className="label_field_supershop_purchase"
                                            style={newWidth}
                                        >
                                            Net Total
                                        </label>
                                        <input
                                            type="number"
                                            style={newWidth}
                                            value={NettotalAmount}
                                        />
                                    </div>
                                </div>

                                <div className="input_field_short_purchase">
                                    <label
                                        className="label_field_supershop_purchase"
                                        style={newWidth}
                                    >
                                        Paid*
                                    </label>
                                    <input
                                        type="number"
                                        value={paid}
                                        onChange={handlePaidChange}
                                    />
                                </div>
                                <div className="input_field_short_purchase">
                                    <label
                                        className="label_field_supershop_purchase"
                                        style={newWidth}
                                    >
                                        Due
                                    </label>
                                    <input type="number" value={duePaid} style={newWidth} />
                                </div>
                            </div>
                            <div
                                className="first_column_second_row"
                                style={{
                                    background: "rgba(255, 230, 240, 0.3)", /* light pink with 70% opacity */
                                }}
                            >
                                <div
                                    className="first_column_second_row_input_field"
                                    style={{
                                        background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                                    }}
                                >
                                    <div>
                                        <div className="input_field_short_select">
                                            <label className="label_field_supershop_purchase">
                                                Shop
                                            </label>
                                            <select>
                                                {shopNameData &&
                                                    shopNameData.map((shop) => (
                                                        <option
                                                            value={shop.shop_name_id}
                                                            key={shop.shop_name_id}
                                                        >
                                                            {shop.shop_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                        <div className="input_field_short_select1">
                                            <label className="label_field_supershop_purchase">
                                                Employee
                                            </label>
                                            <select>
                                                <option>{Employee}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="input_field_short_date">
                                            <label className="label_field_supershop_purchase">
                                                Purchase Date
                                            </label>
                                            <input
                                                type="date"
                                                className="input_field_supershop_purchase_long"
                                                value={todayDate}
                                                onChange={(e) => setTodayDate(e.target.value)}
                                            />
                                        </div>
                                        <div className="input_field_short_select1">
                                            <label className="label_field_supershop_purchase">
                                                Payment Type
                                            </label>
                                            <select
                                                name=""
                                                id=""
                                                value={paymentType}
                                                onChange={(e) => setPaymentType(e.target.value)}
                                            >
                                                {paymentTypeData.map((data) => (
                                                    <option
                                                        key={data.payment_id}
                                                        value={data.payment_type}
                                                    >
                                                        {data.payment_type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="button_first_column_second_row"
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        columnGap: "3vw",
                                        // marginTop: 1.7vw;
                                        marginLeft: "12vw",
                                        justifyContent: "center",
                                    }}
                                >
                                    <div className="container_button_supershop_expance_input"
                                        style={{
                                            background: "rgba(255, 230, 240, 0.0)", /* light pink with 70% opacity */

                                        }}
                                    >
                                        <div style={{ display: "none" }}>
                                            <ComponentToPrint
                                                ref={componentRef}
                                                supplier={supplierName}
                                                address={Supplieraddress}
                                                mobile={Suppliermobile}
                                                employee_name={Employee}
                                                date={todayDate}
                                                total={NettotalAmount}
                                                due={duePaid}
                                                paid={paid}
                                                invoice={invoice}
                                                rows={tableData}
                                                vat={vat}
                                            />
                                        </div>
                                        <button
                                            style={{
                                                alignItems: "center",
                                                background: "#000",
                                                width: "3vw",
                                                height: "3vw"
                                            }}
                                            onClick={handlePrint}
                                        >
                                            <BiPrinter className="print_icon" title="Print" />
                                        </button>
                                        Print
                                    </div>

                                    <div
                                        className="container_button_supershop_expance_input"
                                        style={{
                                            background: "rgba(255, 230, 240, 0.0)", /* light pink with 70% opacity */

                                        }}
                                    >
                                        {/* <button
                      style={{
                        alignItems: "center",
                        background:"#000",
                      }}
                      onClick={handleSave}
                    >
                      <IoIosSave/>
                    </button> */}
                                        <StylishHoverButtonInvoice onClick={handleSave} />
                                        Save
                                    </div>
                                    <div className="container_button_supershop_expance_input"
                                        style={{
                                            background: "rgba(255, 230, 240, 0.0)", /* light pink with 70% opacity */

                                        }}
                                    >
                                        {/* <button
                      style={{
                        alignItems: "center",
                        background:"#000",
                      }}
                      onClick={handleReset}
                    >
                    <BiReset 
                        style={{
                            backgroundColor:"#000",
                                     
                          }}
                    />
                    </button> */}
                                        <StylishHoverButtonReset onClick={handleReset} />
                                        {/* Reset */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="popup-window_supershop">
                        <Modal
                            title="Add Supplier"
                            open={visible}
                            onCancel={handleCancel}
                            width={730}
                            footer={null}
                            style={{
                                top: 46,
                                bottom: 0,
                                left: 0,
                                right: 0,
                            }}
                        >
                            <div className="container_permanent_supplier_supershop">
                                <div className="first_row_div_permanent_supplier_supershop">
                                    <div className="container_search_permanent_supplier_supershop">
                                        <div className="container_separate_permanent_supplier_supershop">
                                            <div>
                                                <div className="search_permanent_supplier_supershop">
                                                    <div className="search_permanent_supplier_supershop_column1">
                                                        <div className="input_field_permanent_supplier_supershop">
                                                            <label>Supplier Name*</label>
                                                            <input
                                                                type="text"
                                                                value={contributor_name}
                                                                onChange={(e) => {
                                                                    setContributorName(e.target.value);
                                                                    setcontributorNameError("");
                                                                }}
                                                                style={{
                                                                    borderColor:
                                                                        contributorNameError &&
                                                                            contributor_name === ""
                                                                            ? "red"
                                                                            : "",
                                                                }}
                                                            />
                                                            <div className="error_message_supplier">
                                                                {contributorNameError && contributor_name === ""
                                                                    ? contributorNameError
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="search_permanent_supplier_supershop_column2">
                                                        <div className="input_field_permanent_supplier_supershop">
                                                            <label>Mobile*</label>
                                                            <input
                                                                type="text"
                                                                value={mobile}
                                                                onChange={(e) => {
                                                                    setMobile(e.target.value);
                                                                    setMobileError("");
                                                                }}
                                                                style={{
                                                                    borderColor:
                                                                        mobileError && mobile === "" ? "red" : "",
                                                                }}
                                                            />
                                                            <div className="error_message_supplier">
                                                                {mobileError && mobile === ""
                                                                    ? mobileError
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                        <div className="input_field_permanent_supplier_supershop">
                                                            <label>Address*</label>
                                                            <input
                                                                type="text"
                                                                value={address}
                                                                onChange={(e) => {
                                                                    setAddress(e.target.value);
                                                                    setAddressError("");
                                                                }}
                                                                style={{
                                                                    borderColor:
                                                                        addressError && address === "" ? "red" : "",
                                                                }}
                                                            />
                                                            <div className="error_message_supplier">
                                                                {addressError && address === ""
                                                                    ? addressError
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="save-and-delete-button-supplier">
                                                {supplierId ? (
                                                    <div className="save_button">
                                                        <button
                                                            className="button_supershop button2"
                                                            onClick={handleupdateSupplier}
                                                        >
                                                            <img src={update} alt="" />
                                                        </button>
                                                        Update
                                                    </div>
                                                ) : (
                                                    <div className="save_button">
                                                        <button
                                                            className="button_supershop button2"
                                                            onClick={handleSaveSupplier}
                                                        >
                                                            <img src={Save} alt="" />
                                                        </button>
                                                        Save
                                                    </div>
                                                )}
                                                <div className="save_button">
                                                    <button
                                                        className="button_supershop button2"
                                                        onClick={handleDeleteSupplier}
                                                    >
                                                        <img src={Delete} alt="" />
                                                    </button>
                                                    Delete
                                                </div>
                                                <div className="save_button">
                                                    <button
                                                        className="button_supershop button2"
                                                        onClick={HandleResetSupplier}
                                                    >
                                                        <img src={reset} alt="" />
                                                    </button>
                                                    Reset
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="searchbar_supplier">
                                    <div className="input_field_brand_supershop">
                                        <label>Supplier Name</label>
                                        <input
                                            type="text"
                                            value={searchSupplierName}
                                            onChange={(e) => {
                                                setSearchSupplierName(e.target.value);
                                            }}
                                            list="supplier"
                                        />
                                        <datalist id="supplier">
                                            {supplierData.length > 0 &&
                                                supplierData.map((customer, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={customer.contributor_name}
                                                        >
                                                            {customer.contributor_name}
                                                        </option>
                                                    );
                                                })}
                                        </datalist>
                                    </div>
                                    <div className="searchbar_buttton">
                                        <button onClick={handleSupplierSearch}>Search</button>
                                    </div>
                                    <div
                                        className="searchbar_buttton"
                                        style={{ marginLeft: "4vw" }}
                                    >
                                        <button onClick={fetchSupplierData}>Show All</button>
                                    </div>
                                </div>
                                <div className="second_row_modal">
                                    <div className="table_div_modal" ref={tableRef}>
                                        <table border={1} cellSpacing={1} cellPadding={2}>
                                            <tr>
                                                <th>Serial No</th>

                                                <th>Name</th>
                                                <th>Mobile</th>
                                                <th>Address</th>
                                            </tr>
                                            {supplierData &&
                                                supplierData.map((item, index) => (
                                                    <tr
                                                        style={{ cursor: "pointer" }}
                                                        className={
                                                            item.contributor_name_id === supplierId
                                                                ? "activeRow"
                                                                : ""
                                                        }
                                                        onClick={() => handleSupplierRow(item, index)}
                                                    >
                                                        <td>{index + 1}</td>

                                                        <td>{item.contributor_name}</td>
                                                        <td>{item.mobile}</td>
                                                        <td>{item.address}</td>
                                                    </tr>
                                                ))}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <Modal
                        title="Add Brand"
                        open={brandVisible}
                        onCancel={handleBrandCancel}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                        width={600}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Brand Name</label>
                                                        <input
                                                            type="text"
                                                            value={brand_name}
                                                            onChange={(e) => {
                                                                setBrand_name(e.target.value);
                                                                setBrandError("");
                                                            }}
                                                            style={{
                                                                borderColor:
                                                                    brandError && brand_name === "" ? "red" : "",
                                                            }}
                                                        />

                                                        <div className="error_message_brand_save">
                                                            {brandError && brand_name === ""
                                                                ? brandError
                                                                : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="save_and_delete_brand">
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={saveBrandName}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleDeleteBrand}
                                                >
                                                    <img src={Delete} alt="" />
                                                </button>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Brand Name</th>
                                        </tr>
                                        {brandData &&
                                            brandData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={
                                                        item.brand_id === brandId ? "activeRow" : ""
                                                    }
                                                    onClick={() => handleBrandRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.brand_name}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        title="Add Category"
                        open={categoryModal}
                        onCancel={() => setCategoryModal(false)}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                        width={600}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Category Name</label>
                                                        <input
                                                            type="text"
                                                            value={category_name}
                                                            onChange={(e) => {
                                                                setCategoryName(e.target.value);
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="save_and_delete_brand">
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleCategorySave}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleDeleteCategory}
                                                >
                                                    <img src={Delete} alt="" />
                                                </button>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Category Name</th>
                                        </tr>
                                        {categoryData &&
                                            categoryData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={
                                                        item.category_id === categoryId ? "activeRow" : ""
                                                    }
                                                    onClick={() => handleCategoryRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.category_name}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        title="Add Material"
                        open={materialModal}
                        onCancel={() => setMaterialModal(false)}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                        width={600}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Material Name</label>
                                                        <input
                                                            type="text"
                                                            value={material_name}
                                                            onChange={(e) => {
                                                                setMaterialName(e.target.value);
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="save_and_delete_brand">
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleMaterialSave}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleDeleteMaterial}
                                                >
                                                    <img src={Delete} alt="" />
                                                </button>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Material Name</th>
                                        </tr>
                                        {materialData &&
                                            materialData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={
                                                        item.material_id === materialId ? "activeRow" : ""
                                                    }
                                                    onClick={() => handleMaterialRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.material_name}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        title="Add Color"
                        open={colorModal}
                        onCancel={() => setColorModal(false)}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                        width={600}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Color Name</label>
                                                        <input
                                                            type="text"
                                                            value={color}
                                                            onChange={(e) => {
                                                                setColor(e.target.value);
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="save_and_delete_brand">
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleColorSave}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleDeleteColor}
                                                >
                                                    <img src={Delete} alt="" />
                                                </button>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Color Name</th>
                                        </tr>
                                        {colorData &&
                                            colorData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={
                                                        item.id_color === colorID ? "activeRow" : ""
                                                    }
                                                    onClick={() => handlColorRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.color_name}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        title="Add Size"
                        open={sizeModal}
                        onCancel={() => setSizeModal(false)}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                        width={600}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Size Name</label>
                                                        <input
                                                            type="text"
                                                            value={size_name}
                                                            onChange={(e) => {
                                                                setSizeName(e.target.value);
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="save_and_delete_brand">
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleSizeSave}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleDeleteSize}
                                                >
                                                    <img src={Delete} alt="" />
                                                </button>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Size Name</th>
                                        </tr>
                                        {sizeData &&
                                            sizeData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={item.id_size === sizeID ? "activeRow" : ""}
                                                    onClick={() => handlSizeRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.size_name}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        title="Add Unit"
                        open={unitvisible}
                        onCancel={handleUnitCancel}
                        width={600}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Unit Name</label>
                                                        <input
                                                            type="text"
                                                            value={unit}
                                                            onChange={(e) => {
                                                                setUnit(e.target.value);
                                                                setunitError("");
                                                            }}
                                                            style={{
                                                                borderColor:
                                                                    unitError && unit === "" ? "red" : "",
                                                            }}
                                                        />

                                                        <div className="error_message_brand_save">
                                                            {unitError && unit === "" ? unitError : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <div
                                                className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handlesaveUnit}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                        </div>
                                        <div className="brand_save_button">
                                            <button
                                                className="button_supershop button2"
                                                onClick={handleDeleteUnit}
                                            >
                                                <img src={Delete} alt="" />
                                            </button>
                                            <span>Delete</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Unit Name</th>
                                        </tr>
                                        {unitData &&
                                            unitData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={item.unit_id === unitID ? "activeRow" : ""}
                                                    onClick={() => handleUnitRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.unit}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        title="Add Rack"
                        open={RackModal}
                        onCancel={() => setRackModal(false)}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                        width={600}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Rack Number</label>
                                                        <input
                                                            type="text"
                                                            value={rack_no}
                                                            onChange={(e) => {
                                                                setRackNo(e.target.value);
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="save_and_delete_brand">
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleRackSave}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handleDeleteRack}
                                                >
                                                    <img src={Delete} alt="" />
                                                </button>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second_row_modal">
                                <div
                                    className="table_div_modal"
                                    style={{ marginRight: "10px" }}
                                    ref={tableRef}
                                >
                                    <table border={1} cellSpacing={1} cellPadding={2}>
                                        <tr>
                                            <th>Serial No</th>
                                            <th>Rack</th>
                                        </tr>
                                        {rackData &&
                                            rackData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ cursor: "pointer" }}
                                                    className={item.rack_id === rackId ? "activeRow" : ""}
                                                    onClick={() => handlRackRow(item, index)}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.rack_no}</td>
                                                </tr>
                                            ))}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        title="Add Vat"
                        open={vatVisible}
                        onCancel={handleVatCancel}
                        width={500}
                        height={800}
                        footer={null}
                        style={{
                            top: 46,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        }}
                    >
                        <div className="container_permanent_supplier_supershop">
                            <div className="first_row_div_permanent_supplier_supershop">
                                <div className="container_search_permanent_supplier_supershop">
                                    <div className="container_separate_permanent_supplier_supershop">
                                        <div>
                                            <div className="search_permanent_supplier_supershop">
                                                <div className="search_permanent_supplier_supershop_column1">
                                                    <div className="input_field_permanent_supplier_supershop">
                                                        <label>Vat</label>
                                                        <input
                                                            type="text"
                                                            value={rate}
                                                            onChange={(e) => {
                                                                setRate(e.target.value);
                                                                setVatError("");
                                                            }}
                                                            style={{
                                                                borderColor:
                                                                    vatError && rate === "" ? "red" : "",
                                                            }}
                                                        />
                                                        <div className="error_message_brand_save">
                                                            {vatError && rate === "" ? vatError : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="brand_save_button">
                                                <button
                                                    className="button_supershop button2"
                                                    onClick={handlesaveVat}
                                                >
                                                    <img src={Save} alt="" />
                                                </button>
                                                <span>Save</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    );
};

export default PurchaseOperation;
